"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedTimezone = exports.getLocaleByCountry = void 0;
var __1 = require("..");
var helper_1 = require("../utils/helper");
var base_1 = require("../date/base");
// 根据用户传入的国家码获取默认locale
var getLocaleByCountry = function (country) {
    var _a, _b;
    (0, helper_1.validateFunction)(country, 'country', 'getLocaleByCountry const');
    // 当传入错误的国家，就取用户init时的locale
    return ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.countryBaseInfo[country])
        ? "".concat((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.countryBaseInfo[country].lang.split(',')[0], "-").concat(country)
        : __1.Config.locale;
};
exports.getLocaleByCountry = getLocaleByCountry;
// 判断是否为elvish支持的timezone
var isSupportedTimezone = function (timezone) {
    (0, helper_1.validateFunction)(timezone, 'timezone', 'isSupportedTimezone const');
    return !!base_1.DateFormat.timeZoneList.timezones[timezone];
};
exports.isSupportedTimezone = isSupportedTimezone;
